var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 10C14.1667 7.7 12.3 5.83333 10 5.83333C9.45834 5.83333 8.95001 5.94167 8.47501 6.13333L6.67501 4.33333C7.70834 3.95833 8.82501 3.75 9.99168 3.75C14.1583 3.75 17.7167 6.34167 19.1583 10C18.55 11.55 17.5583 12.9083 16.3 13.9583L13.8667 11.525C14.0583 11.05 14.1667 10.5417 14.1667 10ZM3.56668 5.45833L1.66668 3.55833L2.72501 2.5L17.5 17.275L16.4417 18.3333L14 15.9L13.65 15.55C12.525 16 11.2917 16.25 10 16.25C5.83334 16.25 2.27501 13.6583 0.833344 10C1.48334 8.35 2.56668 6.91667 3.95001 5.84167L3.56668 5.45833ZM7.56668 9.45833L6.27501 8.16667C6.00001 8.725 5.83334 9.34167 5.83334 10C5.83334 12.3 7.70001 14.1667 10 14.1667C10.6583 14.1667 11.275 14 11.8333 13.725L10.5417 12.4333C10.3667 12.475 10.1833 12.5 10 12.5C8.61668 12.5 7.50001 11.3833 7.50001 10C7.50001 9.81667 7.52501 9.63333 7.56668 9.45833ZM12.4917 10.1417L9.86668 7.51667L10.0083 7.50833C11.3917 7.50833 12.5083 8.625 12.5083 10.0083L12.4917 10.1417Z",
    fill: "#3A4861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/Archive.08530380ad9dce77467cca5d4a4fae9b.svg";
export { ForwardRef as ReactComponent };